export default {
  isActive_Bottom: true,
  isActive: true,
  isActive0: false
}